import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/models';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const goalType = action?.payload?.goalType;
    const qs = goalType ? `?goal_type=${encodeURIComponent(goalType)}` : '';
    const response = yield call(
      axios.get,
      `${config.API_URL}/goals/model-lineup${qs}`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response?.data?.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
